var logUtil = require("./logutil.js");

var logFunctionGroups = [];

var logFunctionStore = {

    storeLogFunctions: function (accessName, logger) {

        if (accessName == null) {
            return this;
        }

        if (logFunctionGroups[accessName] != null) {
            return this;
        }

        if (logger == null) {
            logger = {};
        }

        logFunctionGroups[accessName] = {};

        logUtil.copyLoggerFunctions(logger, logFunctionGroups[accessName]);

        return this;
    },

    applyLogFunctions: function (accessName, logger) {

        if (accessName == null || logger == null ||
            logFunctionGroups[accessName] == null) {
            return this;
        }

        logUtil.copyLoggerFunctions(logFunctionGroups[accessName], logger);

        return this;
    }
};

module.exports = logFunctionStore;